import { render, staticRenderFns } from "./buyList.vue?vue&type=template&id=c74bcb72"
import script from "./buyList.vue?vue&type=script&lang=js"
export * from "./buyList.vue?vue&type=script&lang=js"
import style0 from "./buyList.vue?vue&type=style&index=0&id=c74bcb72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports